export const figure21a = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 300,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'Etiopía'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2014', '2016', '2019']
},
labels: {
format: '{value}',
style: {
       fontWeight: 'normal',
       color: '#999999',
       fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 2500,
tickInterval: 500,
labels: {
    format: '{value:,.0f}',
    style: {
		    fontWeight: 'normal',
		    color: '#999999',
		    fontSize: '12px'
	    },
},
title: {
    text: null,
},
},
plotOptions: {
series: {
       marker: {
		       enabled: false,
		       states: {
					hover: {
						       enabled: false
					       }
				}
	       }
},	
line: {
       dataLabels: {
			   enabled: false
		   },
		   enableMouseTracking: true
}
},
legend: {
enabled: false,
},
colors: ['#5a99d3', '#f5b493','#a5a5a5', '#fdc201'],
series: [{
name: 'Pequeños productores',
data: [430, 473, 678]
}, {
name: 'Productores no pequeños',
data: [917, 1060, 2236]
},{
name: 'Unidades de pequeños productores dirigidas por mujeres',
data: [326, 323, 470]
},{
name: 'Unidades de pequeños productores dirigidas por hombres',
data: [464, 529, 756]
       }]
}
